import { useTheme as e } from "styled-components";
const s = e;
export {
  s as useTheme
};
